import {Action, Selector, State, StateContext} from '@ngxs/store';

import {Injectable} from '@angular/core';
import {LoadAppSettings, SetBrand, SetLayoutType} from './actions';
import {BrandName} from '@commonShared/models';
import {take} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import {firstValueFrom} from 'rxjs';


export enum Layout {
  MOBILE = 'MOBILE',
  DESKTOP = 'DESKTOP',
}

export interface Settings {
  brand: string;
  googleMapsApiKey: string;
}

interface SharedModel {
  brand: string;
  layoutType: Layout;
  settingsLoaded: boolean;
  googleMapsApiKey: string;
}

@State<SharedModel>({
  name: 'shared',
  defaults: {
    brand: BrandName.GENERALI,
    layoutType: Layout.MOBILE,
    settingsLoaded: false,
    googleMapsApiKey: null
  }
})
@Injectable()
export class SharedState {

  constructor(private http: HttpClient) {
  }

  @Selector()
  static brand(state: SharedModel) {
    return state.brand;
  }

  @Selector()
  static brandName(state: SharedModel) {
    return state.brand.toLocaleLowerCase();
  }

  @Selector()
  static isBrandGenerali(state: SharedModel) {
    return state.brand === BrandName.GENERALI;
  }

  @Selector()
  static isBrandProama(state: SharedModel) {
    return state.brand === BrandName.PROAMA;
  }

  @Selector()
  static layout(state: SharedModel) {
    return state.layoutType;
  }

  @Selector()
  static settingsLoaded(state: SharedModel) {
    return state.settingsLoaded;
  }

  @Selector()
  static googleMapsApiKey(state: SharedModel) {
    return state.googleMapsApiKey;
  }

  @Action(SetBrand)
  loadCurrentUser(ctx: StateContext<SharedModel>, action: SetBrand) {
    ctx.patchState({
      brand: action.brand,
    })
  }

  @Action(SetLayoutType)
  setLayoutType(ctx: StateContext<SharedModel>, action: SetLayoutType) {
    ctx.patchState({
      layoutType: action.layoutType,
    })
  }

  @Action(LoadAppSettings)
  loadSettings(ctx: StateContext<SharedModel>) {
    firstValueFrom(this.http.get('auto-liquidation/settings').pipe(take(1)))
      .then((settings: Settings) => {
      ctx.patchState({
        brand: !!settings.brand ? settings.brand : ctx.getState().brand,
        googleMapsApiKey: settings.googleMapsApiKey,
        settingsLoaded: true
      });
    });
  }
}
